import { useEffect } from 'react';

import { getServerLogKeyFromClient } from '@/utils/server-log';

interface ServerLogItem {
  result?: string;
  url?: string;
  errMessage?: string;
}

interface ServerLogResponse {
  code: number;
  message: string;
  data: { result: string; total: number; list: ServerLogItem[] } | null;
}

/** 拉取 axios 拦截器写入 redis 的服务端请求日志，服务端取到后直接清空列表 */
async function consumeServerLogs() {
  const res = await fetch('/api/server-logs', {
    cache: 'no-store',
  });
  const json = (await res.json()) as ServerLogResponse;
  const list = json?.data?.list ?? [];
  if (!list.length) {
    return [];
  }
  return list;
}

export function useReportServerLogs() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENV === 'prod') {
      return;
    }
    const listKey = getServerLogKeyFromClient();
    if (!listKey) {
      return;
    }
    consumeServerLogs().then(list => {
      if (list?.length) {
        const errorItems = list.filter(item => item?.result === 'error');
        if (errorItems.length) {
          const detail = errorItems
            .map(
              item =>
                `url: ${item.url ?? 'unknown'}, errMessage: ${item.errMessage ?? 'unknown'}`,
            )
            .join('\n');
          throw new Error(`服务端接口请求错误:\n${detail}`);
        }
      }
    });
  }, []);
}
